/**
 * Generated runtime TestId mirror for frontend/src/components/observability/SpanWaterfall.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const SpanWaterfallTestIds = {
  colDuration: "col-duration",
  colSpan: "col-span",
  colStatus: "col-status",
  filterAll: "filter-all",
  sortDuration: "sort-duration",
  sortTime: "sort-time",
  spanWaterfall: "span-waterfall",
  filter: (kind: string) => `filter-${kind}`,
  filterPrefix: () => "filter-" as TestIdPrefix,
  spanDetail: (span_spanId: string) => `span-detail-${span_spanId}`,
  spanDetailPrefix: () => "span-detail-" as TestIdPrefix,
  waterfallRow: (span_spanId: string) => `waterfall-row-${span_spanId}`,
  waterfallRowPrefix: () => "waterfall-row-" as TestIdPrefix
} as const;
